export const firebaseConfig = {
  apiKey: "AIzaSyAFsukXGzpODY0QttmOF5XSbBPqjpk4z_g",
  authDomain: "chessroyale-3e15a.firebaseapp.com",
  projectId: "chessroyale-3e15a",
  storageBucket: "chessroyale-3e15a.appspot.com",
  messagingSenderId: "782230085124",
  appId: "1:782230085124:web:ee569029ab913b64285f51",
  measurementId: "G-YY37HCL6P7"
};
